(function () {
  if (window.EvryVariantBlink) return;

  var MOBILE_QUERY = '(max-width: 749px)';
  var OUT_CLASS = 'evry-variant-swap--out';
  var IN_CLASS = 'evry-variant-swap--in';
  var FADE_OUT_MS = 40;
  var FADE_IN_MS = 100;
  var LOAD_TIMEOUT_MS = 3000;

  function isMobileViewport() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  /**
   * @param {string | undefined} url
   * @param {number} timeoutMs
   */
  function preloadImage(url, timeoutMs) {
    return new Promise(function (resolve) {
      if (!url) {
        resolve();
        return;
      }

      var settled = false;

      function done() {
        if (settled) return;
        settled = true;
        resolve();
      }

      window.setTimeout(done, timeoutMs);

      var img = new Image();
      img.onload = done;
      img.onerror = done;
      img.src = url;

      if (img.complete) {
        done();
      }
    });
  }

  /**
   * @param {Element} container
   */
  function clearSwapClasses(container) {
    container.classList.remove(OUT_CLASS, IN_CLASS);
  }

  /**
   * @param {{
   *   container?: Element | null,
   *   imageUrl?: string,
   *   applyImage?: () => void
   * }} options
   */
  function swapVariantImage(options) {
    var container = options.container;
    var applyImage = options.applyImage;
    var imageUrl = options.imageUrl;

    if (!container || !isMobileViewport()) {
      if (applyImage) applyImage();
      return;
    }

    var outComplete = false;
    var imageReady = false;
    var swapped = false;

    function finishIn() {
      clearSwapClasses(container);
      void container.offsetWidth;
      container.classList.add(IN_CLASS);

      window.setTimeout(function () {
        container.classList.remove(IN_CLASS);
      }, FADE_IN_MS);
    }

    function trySwap() {
      if (swapped || !outComplete || !imageReady) return;

      swapped = true;
      if (applyImage) applyImage();
      finishIn();
    }

    clearSwapClasses(container);
    void container.offsetWidth;
    container.classList.add(OUT_CLASS);

    window.setTimeout(function () {
      outComplete = true;
      trySwap();
    }, FADE_OUT_MS);

    preloadImage(imageUrl, LOAD_TIMEOUT_MS).then(function () {
      imageReady = true;
      trySwap();
    });
  }

  window.EvryVariantBlink = {
    swap: swapVariantImage,
  };
})();
